import React, { FunctionComponent } from 'react';
import { Form, Field } from 'react-final-form';
import { ArrowBackOutlined } from '@mui/icons-material';
import i18next from 'i18next';

import { filesValidation, requiredValidation } from 'helpers/validations';
import { history } from 'helpers/history';

import Input from 'components/inputs/Input';
import SelectInput from 'components/inputs/SelectInput';

import { ViewContainer, ViewContent, TitleContainer, Title, CustomIconButton } from 'styles/view';
import { FormContent, FormButtonContainer, FormSubmitButton } from 'styles/form';

import { IProceduresFormProps } from './types';
import './i18n';

const ProceduresForm: FunctionComponent<IProceduresFormProps> = (props: IProceduresFormProps) => {
  const { files, initialValues, isEditing, onDeleteFile, onSubmit, states } = props;

  return (
    <ViewContainer auth data-testid="procedures-form">
      <ViewContent auth>
        <TitleContainer>
          <CustomIconButton onClick={history.goBack}>
            <ArrowBackOutlined />
          </CustomIconButton>
          <Title>{i18next.t<string>('PROCEDURES_FORM:TITLE')}</Title>
          <div />
        </TitleContainer>
        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
          render={({ handleSubmit, submitting, pristine }) => (
            <FormContent onSubmit={handleSubmit}>
              <Field
                label={i18next.t<string>('PROCEDURES_FORM:NAME')}
                name="name"
                render={Input}
                validate={requiredValidation}
              />
              {isEditing && (
                <Field
                  label={i18next.t<string>('PROCEDURES_FORM:STATE')}
                  name="state"
                  options={states}
                  render={SelectInput}
                  validate={requiredValidation}
                />
              )}
              <Field
                label={i18next.t<string>('PROCEDURES_FORM:FILES')}
                multiple
                name="files"
                onDeleteFile={onDeleteFile}
                previewFiles={files}
                render={Input}
                type="file"
                validate={filesValidation}
              />
              <FormButtonContainer>
                <FormSubmitButton disabled={pristine || submitting} type="submit">
                  {i18next.t<string>('PROCEDURES_FORM:SUBMIT_BUTTON')}
                </FormSubmitButton>
              </FormButtonContainer>
            </FormContent>
          )}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default ProceduresForm;
